"use client";

import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { ReactNode } from "react";

export interface ExpertiseCardItem {
  icon: ReactNode;
  title: string;
  description: string;
  checked?: boolean;
}

export interface ExpertiseCardProps {
  icon: ReactNode;
  title: string;
  items: ExpertiseCardItem[];
}

export const ExpertiseCard = ({ icon, title, items }: ExpertiseCardProps) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true, margin: "-50px" }}
    className="bg-card border border-border rounded-xl p-8 shadow-sm group"
  >
    <div className="flex items-center gap-4 mb-6">
      <div className="flex items-center justify-center bg-secondary w-12 h-12 rounded-lg transition-transform duration-200 group-hover:scale-110">
        {icon}
      </div>
      <h2 className="text-2xl font-bold tracking-tight text-primary">{title}</h2>
    </div>
    <ul className="space-y-6">
      {items.map((item) => (
        <li
          key={item.title}
          className="flex items-start gap-4 rounded-lg transition-all duration-200 cursor-pointer hover:shadow-sm hover:-translate-y-0.5"
        >
          <div className="mt-1">
            {item.checked ? <CheckCircle className="w-6 h-6 text-primary" /> : item.icon}
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-1">{item.title}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">{item.description}</p>
          </div>
        </li>
      ))}
    </ul>
  </motion.div>
); 